import React from "react";
import { GlobeIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
import { CheckList } from "../CheckList";
import { offerIncludes, offerItems } from "../../data/content";
import { MOCKUP_URL, PRICE, REFERENCE_PRICE } from "../../data/site";
export function OfferSection() {
  return <section id="offer" className="bg-navy px-4 py-16 sm:py-24" data-id="element-246" data-mp="6hq59g6zund3">
      <div className="mx-auto max-w-3xl" data-id="element-247" data-mp="6j17hbksjn23">
        <div className="text-center" data-id="element-248" data-mp="1q80eh1uo2mu">
          <p className="text-sm font-extrabold uppercase tracking-[0.14em] text-gold" data-id="element-249" data-mp="1p6roj8b3s8a">Special introductory offer</p>
          <h2 className="mt-3 text-[1.9rem] font-extrabold leading-[1.12] tracking-tight text-white sm:text-5xl" data-id="element-250" data-mp="3sug8bkaeuu58">
            Here’s everything you’ll receive today
          </h2>
        </div>

        <img src={MOCKUP_URL} alt="The complete Hemodynamic Monitoring Blueprint collection" className="mx-auto mt-8 w-full max-w-md" data-id="element-251" data-mp="3j0pl0iq0spr4" />

        <div className="mt-8 overflow-hidden rounded-3xl bg-white" data-id="element-252" data-mp="1arigmdc9loeb">
          <div className="flex items-center justify-between bg-canvas px-5 py-3 text-xs font-extrabold uppercase tracking-wider text-muted sm:px-7" data-id="element-253" data-mp="1aq7cgcewqemo">
            <span data-id="element-254" data-mp="10uvxbszl75ee">Your complete collection</span>
            <span data-id="element-255" data-mp="10s00k7zh6mrj">Value</span>
          </div>
          <ul className="divide-y divide-line" data-id="element-256" data-mp="15tz5hmav5rql">
            {offerItems.map(item => <li key={item.label} className="flex items-start justify-between gap-4 px-5 py-4 sm:px-7" data-id="element-257" data-mp="1ti8n0c11ntbx">
                <span className="text-[15px] font-semibold leading-snug text-ink sm:text-base" data-id="element-258" data-mp="1ygjuwh7s3tri">{item.label}</span>
                <span className="shrink-0 text-base font-bold text-muted line-through" data-id="element-259" data-mp="1kh227qrd3wcv">{item.value}</span>
              </li>)}
          </ul>
          <div className="flex items-center justify-between gap-4 border-t-2 border-navy bg-canvas px-5 py-4 sm:px-7" data-id="element-260" data-mp="92okz4r46f5t">
            <span className="text-base font-extrabold uppercase text-navy" data-id="element-261" data-mp="d4ifswemooy2">Total reference value</span>
            <span className="text-2xl font-extrabold text-alert line-through" data-id="element-262" data-mp="2fr70a8912a4y">{REFERENCE_PRICE}</span>
          </div>

          <div className="px-5 py-8 sm:px-8" data-id="element-263" data-mp="2at5gtm7ow8sy">
            <p className="text-center text-base font-bold uppercase tracking-wide text-navy" data-id="element-264" data-mp="261482a9qd07o">
              Today, get the complete collection for just…
            </p>
            <div className="mt-3 flex items-end justify-center gap-3" data-id="element-265" data-mp="211r9wtdes6ps">
              <span className="text-[5.5rem] font-extrabold leading-none tracking-tight text-cta sm:text-9xl" data-id="element-266" data-mp="1x1h3xgpm9gax">{PRICE}</span>
              <span className="pb-3 text-xl font-bold text-navy" data-id="element-267" data-mp="1rzrvm8ts3gqj">USD</span>
            </div>
            <p className="mt-3 text-center" data-id="element-268" data-mp="1n2rxck367i9z">
              <span className="inline-block rounded-full bg-gold px-4 py-1.5 text-sm font-extrabold uppercase tracking-wide text-navy" data-id="element-269" data-mp="1i36ptl9xq1ln">
                One-time payment · Save approx. 89%
              </span>
            </p>

            <div className="mt-8" data-id="element-270" data-mp="3cgy633mrrjq2">
              <CheckList items={offerIncludes} columns data-id="element-271" data-mp="3chzfz4s1u067" />
            </div>

            <div className="mt-8" data-id="element-272" data-mp="3kx5eej3mezjk">
              <CtaButton label="Yes! I want the complete Blueprint™ for $27" data-id="element-273" data-mp="3kw44ihyccj3f" />
            </div>
            <Countdown data-id="element-274" data-mp="3oxpenvjhqj9x" />
            <ScarcityBar data-id="element-275" data-mp="3tqilqq2fm3p6" />

            <div className="mx-auto mt-5 flex max-w-xl items-start gap-2.5 rounded-2xl bg-brand-soft p-4" data-id="element-276" data-mp="3tq8rgqactado">
              <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-277" data-mp="2j60nzyfh63z" />
              <p className="text-sm leading-relaxed text-ink" data-id="element-278" data-mp="320e24tmhxkp0">
                <strong data-id="element-279" data-mp="360xznyazeqbo">Automatic currency conversion.</strong> Paying from outside the United States? The price is converted to your local
                currency automatically, and the final amount is shown at checkout before you pay.
              </p>
            </div>

            <p className="mt-5 text-center text-sm font-medium text-muted" data-id="element-280" data-mp="3g0ezhz3jy9zq">One-time payment · Digital educational product</p>
          </div>
        </div>
      </div>
    </section>;
}